<script lang="ts" setup>
  import { h as createElement, computed } from "vue";
  import { TopolTag } from "@/schemas/templateSchema";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const style = computed(() => {
    return mjmlStore.mjml.style;
  });

  const render = () => {
    const styles = [];

    for (const element in style.value) {
      let elementStyles = "";
      for (const elementStyleProp in style.value[element as TopolTag]) {
        const topolTag = style.value[element as TopolTag];

        if (topolTag === undefined) continue;

        const topolTagAttribute =
          topolTag[elementStyleProp as keyof typeof topolTag];

        elementStyles += elementStyleProp + ":" + topolTagAttribute + ";";
      }
      styles.push(
        "#templateContent " +
          element.replaceAll(", ", ", #templateContent ") +
          "{" +
          elementStyles +
          "}"
      );
    }

    return createElement("style", {}, styles);
  };
</script>

<template>
  <render />
</template>
